import stepTypes from '../../../enums/stepTypes'
import stepStatusTypes from '../../../enums/stepStatusTypes'
import getValueInUnit from './getValueInUnit'

const hasNoStatValue = (stats, attrib) => (!stats || !stats[attrib] || !stats[attrib].value || !getValueInUnit(stats[attrib]))
const countStats = (stats, attribs) => attribs.length - attribs.filter(attrib => hasNoStatValue(stats, attrib)).length
const showAnyStatLinks = (stats, attribs) => attribs.some(attrib => hasNoStatValue(stats, attrib))
const availableStats = ['height', 'dateOfBirth', 'weight', 'waist', 'chest', 'chestShape', 'fitPreference', 'stomachShape']

const getProfileStatus = (userProfile, type) => {
	const grab = (attrs, obj) => attrs.map(attr => attr.split('.').reduce((o, i) => (o ? o[i] : undefined), obj)).filter(o => o)
	const getStatusType = (attrs, result) => {
		let status = (result.length === attrs.length) ? stepStatusTypes.COMPLETED : stepStatusTypes.INCOMPLETE
		if (status === stepStatusTypes.INCOMPLETE && result.length > 0) {
			status = stepStatusTypes.IN_PROGRESS
		}
		return status
	}
	const attrObj = {
		[stepTypes.BASICINFO]: ['bio', 'fullName'],
		[stepTypes.YOURKIT]: ['countKitsCreated'],
		[stepTypes.VERIFICATIONS]: ['countVerifiers']
	}
	const attrs = attrObj[type]
	const result = attrs ? grab(attrs, userProfile) : []
	let totalParts = 1
	let doneParts = 0
	let status = stepStatusTypes.INCOMPLETE
	//	Special case for verifications
	if (type === stepTypes.VERIFICATIONS) {
		totalParts = 3
		if (result && result[0] >= 3) {
			doneParts = 3
			status = stepStatusTypes.COMPLETED
		} else if (result && result[0] > 0) {
			doneParts = result[0]
			status = stepStatusTypes.IN_PROGRESS
		}
	//	Special case for fit (stats)
	} else if (type === stepTypes.YOURFIT) {
		totalParts = availableStats.length
		if (userProfile.statistics) {
			doneParts = countStats(userProfile.statistics, availableStats)
			status = !showAnyStatLinks(userProfile.statistics, availableStats) ? stepStatusTypes.COMPLETED : stepStatusTypes.IN_PROGRESS
		}
	//	Special case for kit
	} else if (type === stepTypes.YOURKIT) {
		if (result && result[0] >= 1) {
			doneParts = 1
			status = stepStatusTypes.COMPLETED
		}
	} else {
		status = getStatusType(attrs, result)
		totalParts = attrs.length
		doneParts = result.length
	}
	const completed = status === stepStatusTypes.COMPLETED

	return { status, result, completed, totalParts, doneParts }
}

export default getProfileStatus



// WEBPACK FOOTER //
// ./src/utilities/Data/User/getProfileStatus.js